<template>
    <div class="requisites-page_requisites-empty-state">
        <SlothBlock
            :title="$t('requisites.requisites-filters.empty-state.title')"
            :subtitle="$t('requisites.requisites-filters.empty-state.text')"
            :type="SLOTH_TYPE.QUESTION"
        />
    </div>
</template>

<script setup lang="ts">

import SlothBlock from "@components/messages/SlothBlock.vue";
import {SLOTH_TYPE} from "@/entities/enums/SlothType";
</script>

<style lang="scss">
.requisites-page_requisites-empty-state {

}
</style>